import { Fragment, useEffect, useState } from "react";
import { Card, CardHeader, Col, Row, CardBody, Input, Button, Table, Modal, ModalBody, InputGroup, InputGroupAddon, InputGroupText, ModalHeader } from "reactstrap";
import { translate } from "react-switch-lang";
import { useHttpClient } from "../../../security/hooks/axiosProvider";
import { toast } from "react-toastify";
import SweetAlert from "sweetalert2";
import { DocumentTypeDto } from "../../../models/documentTypeDto";
import styles from "./typeDocument.module.scss";
import AddSetting from "../add-setting/addSetting";
import { TypeSetting } from "../../../models/typeSetting";

function TypeDocument(props: any) {
  toast.configure();
  const httpClient = useHttpClient(true);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [document, setDocument] = useState<DocumentTypeDto>(new DocumentTypeDto());
  const [listDocumentType, setListDocumentType] = useState<DocumentTypeDto[]>([]);
  const [listFiltredDocumentType, setListFiltredDocumentType] = useState<DocumentTypeDto[]>([]);
  const [isOncreate, setIsOncreate] = useState<boolean>(true);

  const toggle = (data: DocumentTypeDto) => {
    setOpenModal(!openModal);
    setDocument(data);
  };

  const handleDeleteTypeDocument = (typeDocumentId: any) => {
    SweetAlert.fire({
      title: props.t("document_type.message_confirmation_delete_document_type"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: String(props.t("button_delete")),
      cancelButtonText: String(props.t("button_cancel")),
      reverseButtons: true,
    }).then(result => {
      if (result.value) {
        httpClient.current?.delete("/document/" + typeDocumentId).then(response => {
          if (response.data) {
            toast.success(String(props.t("message_toastr_delete")), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
            handleGetTypeDocument();
          } else {
            toast.error(String(props.t("document_type.message_toastr_cannot_delete_document_type")), {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
          }
        });
      } else {
      }
    });
  };

  const handleGetTypeDocument = () => {
    httpClient.current?.get("/document").then(response => {
      setListDocumentType(response.data);
      setListFiltredDocumentType(response.data);
    });
  };

  useEffect(() => {
    httpClient.current?.get("/document").then(response => {
      setListDocumentType(response.data);
      setListFiltredDocumentType(response.data);
    });
  }, [httpClient]);

  const handleClickOnUpdate = (data: DocumentTypeDto, index: number) => {
    setIsOncreate(false);
    toggle(data);
  };

  const handleSearch = (value: string) => {
    setListFiltredDocumentType(
      listDocumentType.filter(type => type.titleFrancais.toLocaleLowerCase().includes(value.toLocaleLowerCase()) || type.titleAnglais.toLocaleLowerCase().includes(value.toLocaleLowerCase())),
    );
  };

  return (
    <Fragment>
      <Card>
        <CardHeader className={styles["parametrage-card-header"]}>
          <Row>
            <Col md={12}>
              <div className={styles["parametrage-card-header-input"]}>
                <div className={styles["parametrage-card-inputs"]}>
                  <InputGroup className={styles["categories-search-input-group"]}>
                    <Input onChange={e => handleSearch(e.target.value)} type="search" placeholder={String(props.t("filters.input_placeholder_search"))} />
                    <InputGroupAddon addonType="append">
                      <InputGroupText className={styles["categories-search-input-group-text"]}>
                        <i className={"fa fa-search " + styles["categories-search-input-group-icon"]} />
                      </InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </div>
                <Button
                  outline
                  color="success"
                  className={styles["categories-add-btn"]}
                  onClick={() => {
                    setIsOncreate(true);
                    toggle(new DocumentTypeDto());
                  }}
                >
                  {props.t("document_type.button_add_document_type")}
                </Button>
              </div>
            </Col>
          </Row>
        </CardHeader>

        <CardBody className={styles["parametrage-card-body"]}>
          {listDocumentType.length === 0 ? (
            <div className="text-center">
              <div className={styles["no-data"]}>{props.t("document_type.message_no_document_title")} </div>
              <div className={styles["no-data"]}>{props.t("document_type.message_no_document_type_subtitle")}</div>
            </div>
          ) : (
            <Fragment>
              {
                <Table className={styles["parametrage-card-body"]}>
                  <thead>
                    <tr>
                      <th className={styles["document-table-nom"]} scope="col">
                        <span onClick={() => ""} className={styles["pointer"]}>
                          <i className={""}></i> {props.t("param_table_header.label_image")}
                        </span>
                      </th>
                      <th className={styles["document-table-thematique"]} scope="col">
                        {props.t("param_table_header.label_title_fr")}
                      </th>
                      <th className={styles["document-table-type"]} scope="col">
                        <span onClick={() => ""} className={styles["pointer"]}>
                          <i className={""}></i> {props.t("param_table_header.label_title_en")}
                        </span>
                      </th>

                      <th className={styles["document-table-actions"]} scope="col">
                        {props.t("param_table_header.actions")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {listFiltredDocumentType.map((data: DocumentTypeDto, index: number) => (
                      <tr key={data.documentTypeId}>
                        <td>
                          <img className={styles["parametrage-card-image"]} src={data.urlImage + "/preview"} alt="" />
                        </td>
                        <td className="align-middle">{data.titleFrancais}</td>
                        <td className="align-middle">{data.titleAnglais}</td>

                        <td className={`${styles["document-table-actions-icons"]} align-middle`}>
                          <div>
                            <i className={`${styles["parametrage-actions__btn-update"]} fa fa-edit`} onClick={() => handleClickOnUpdate(data, index)} />
                            <i className={`${styles["parametrage-actions__btn-delete"]} fa fa-trash-o`} onClick={() => handleDeleteTypeDocument(data.documentTypeId)} />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              }
            </Fragment>
          )}
        </CardBody>
      </Card>
      <Modal isOpen={openModal} size="lg">
        <ModalHeader toggle={() => toggle(new DocumentTypeDto())}>{isOncreate ? props.t("document_type.title_create_document_type") : props.t("document_type.title_update_document_type")}</ModalHeader>
        <ModalBody>
          <AddSetting toggle={toggle} handleGet={handleGetTypeDocument} type={TypeSetting.DOCUMENT} settingModal={document}></AddSetting>
        </ModalBody>
      </Modal>
    </Fragment>
  );
}

export default translate(TypeDocument);
